import type { ChatUsageState } from '../chat/chat.ts'
import {
  vFallback,
  vObject,
  vOptional,
  type vOutput,
  vString,
  vStringToNumber,
} from '../validation/index.ts'
import type { AIModel } from './ai.ts'

export const adminChatFilterSchema = vObject({
  limit: vFallback(vStringToNumber(), 50),
  continuationToken: vOptional(vString()),
  accountId: vOptional(vString()),
})
export type AdminChatFilter = vOutput<typeof adminChatFilterSchema>
export const DEFAULT_CHAT_TOKEN_LIMIT = 8_000_000
export const DEFAULT_CHAT_MODEL =
  'gemini-3-flash-preview' as const satisfies AIModel

export type AdminChatUsageState = ChatUsageState & {
  currentUsage: number
  usageLimit: number
}
